import AbstractFilter from '@/classes/filters/AbstractFilter'

export default class HiddenFilter extends AbstractFilter {
  /**
   * Create new hidden filter
   *
   * @param {String} key
   * @param {String} label
   * @param {String} property
   * @param {String} [value]
   */
  constructor (key, label, property, value) {
    super(key, label, property, value)

    this.type = 'HiddenFilter'
  }
}
